export default __webpack_public_path__ + "static/media/MK.94707d5d.svg";